// extracted by mini-css-extract-plugin
export default {"container":"Completion_container__nizxC","okBtn":"Completion_okBtn__gEwiz","contactEmail":"Completion_contactEmail__m4Kjw","sendEmail":"Completion_sendEmail__c2o-S"};